import { __cCollectionService } from '@/services/client/__c.collection.service'
import { ProductQueryParams, ProductResponseFormatted } from '@/types/product'
import { useInfiniteQuery, useQuery } from '@tanstack/react-query'

export function useCollectionProducts(
  params: ProductQueryParams,
  initData?: ProductResponseFormatted,
  filters?: { [key: string]: string[] | string | number | undefined }
) {
  return useInfiniteQuery({
    queryKey: ['collection-products', params, filters],
    queryFn: async ({ pageParam = 1 }) => {
      return await __cCollectionService.getProductsBySlug({
        ...params,
        ...filters,
        page: pageParam,
      })
    },
    initialPageParam: 1,
    initialData: initData
      ? {
          pages: [initData],
          pageParams: [1],
        }
      : undefined,
    getNextPageParam: (lastPage) => {
      if (lastPage.current_page < lastPage.last_page) {
        return lastPage.current_page + 1
      }
      return undefined
    },
  })
}

// list id product và collection id của chương trình x2coolcash
export const useX2CoolCashProducts = () => {
  return useQuery({
    queryKey: ['x2-coolcash-products'],
    queryFn: () => __cCollectionService.getX2CoolCashProducts(),
    staleTime: 1000 * 60 * 5, // Cache data for 5 minutes
    refetchOnWindowFocus: false, // Prevent refetching on window focus
  })
}

// collection no filter
export function useCollectionProductsNoFilter(
  params: ProductQueryParams,
  initData?: ProductResponseFormatted
) {
  return useInfiniteQuery({
    queryKey: ['collection-products-no-filter', params],
    queryFn: async ({ pageParam = 1 }) => {
      return await __cCollectionService.getProductsBySlug({
        ...params,
        page: pageParam,
      })
    },
    initialPageParam: 1,
    initialData: initData
      ? {
          pages: [initData],
          pageParams: [1],
        }
      : undefined,
    getNextPageParam: (lastPage) => {
      if (lastPage.current_page < lastPage.last_page) {
        return lastPage.current_page + 1
      }
      return undefined
    },
  })
}
